import { TableRow } from '@mui/material';
import {
  TemplatesTableRow,
  SlidersTableRow,
  EditRequestsTableRow,
  AllWebinarRow,
  NewWebinarRow,
  ConductorRow,
} from 'containers';
import { BannersRow } from 'containers/TableRow/banners/row';
import { FeaturesRow } from 'containers/TableRow/features/features-table-row';
import { TagsRow } from 'containers/TableRow/tag/tagsRow';
import { TagsRow as RecommendationTagsTableRow } from 'containers/TableRow/recommendation/tag/tagsRow';
import { TagsRow as RecommendationQuestionTableRow } from 'containers/TableRow/recommendation/question/tagsRow';
import { TagsRow as RecommendationConflictTableRow } from 'containers/TableRow/recommendation/conflict/tagsRow';
import { TagsRow as RecommendationRelationTableRow } from 'containers/TableRow/recommendation/relation/tagsRow';

export const RenderTableRow = (name, data, index, actions) => {
  switch (name) {
    case 'templates':
      return <TemplatesTableRow key={index} row={data} index={index} actions={actions} />;
    case 'recommendation_tags':
      return <RecommendationTagsTableRow key={index} row={data} index={index} actions={actions} />;
    case 'recommendation_conflict':
      return <RecommendationConflictTableRow key={index} row={data} index={index} actions={actions} />;
    case 'recommendation_question':
      return <RecommendationQuestionTableRow key={index} row={data} index={index} actions={actions} />;
    case 'recommendation_relation':
      return <RecommendationRelationTableRow key={index} row={data} index={index} actions={actions} />;
    case 'edits':
      return <EditRequestsTableRow key={index} row={data} index={index} actions={actions} />;
    case 'sliders':
      return <SlidersTableRow key={index} row={data} index={index} actions={actions} />;
    case 'tags':
      return <TagsRow key={index} row={data} index={index} actions={actions} />;
    case 'banners':
      return <BannersRow key={index} row={data} index={index} actions={actions} />;
    case 'features':
      return <FeaturesRow key={index} row={data} index={index} actions={actions} />;

    case 'all_webinar':
      return <AllWebinarRow key={index} row={data} index={index} actions={actions} />;

    case 'new_webinar':
      return <NewWebinarRow key={index} row={data} index={index} actions={actions} />;

    case 'on_board':
      return <NewWebinarRow key={index} row={data} index={index} actions={actions} type={'ON_BOARD'} />;

    case 'conductor':
      return <ConductorRow key={index} row={data} index={index} actions={actions} />;

    default:
      return <TableRow />;
  }
};
